import { SxProps, Theme } from "@mui/material";

export const columnStyles = {
  requiredHeaderLabel: {
    fontWeight: 500,
  } as SxProps<Theme>,

  requiredHeaderAsterisk: {
    color: "error.main",
    fontWeight: 500,
  } as SxProps<Theme>,

  lockedBox: {
    color: "text.disabled",
  } as SxProps<Theme>,

  lockIcon: {
    fontSize: 14,
  } as SxProps<Theme>,

  warningIcon: {
    fontSize: 13,
  } as SxProps<Theme>,

  roundedInput: {
    "& .MuiOutlinedInput-root": { borderRadius: "8px" },
  } as SxProps<Theme>,

  disabledFieldBox: {
    border: "1px solid",
    borderColor: "divider",
    borderRadius: "8px",
    px: 1.5,
    py: 0.75,
    bgcolor: "action.disabledBackground",
    color: "text.disabled",
  } as SxProps<Theme>,

  deleteButton: {
    color: "text.disabled",
  } as SxProps<Theme>,
};
